import Vue from 'vue'
import Show from './Show'
import Edit from './Edit'

Vue.component('CompanyShowForm', Show)
Vue.component('CompanyEditForm', Edit)
